import { ScheduleIterator } from "./ScheduleIterator.js";

/**
 * Utility functions for creating common schedule patterns.
 */
export class ScheduleUtils {
  /**
   * Creates a daily schedule.
   * @param startDate - Optional start date (defaults to current date)
   * @param endDate - Optional end date
   * @returns A new ScheduleIterator for daily occurrences
   */
  static daily(startDate?: Date, endDate?: Date): ScheduleIterator {
    return ScheduleIterator.create({
      number: 1,
      unit: "days",
      startDate,
      endDate,
    });
  }

  /**
   * Creates a weekly schedule.
   * @param startDate - Optional start date (defaults to current date)
   * @param endDate - Optional end date
   * @returns A new ScheduleIterator for weekly occurrences
   */
  static weekly(startDate?: Date, endDate?: Date): ScheduleIterator {
    return ScheduleIterator.create({
      number: 1,
      unit: "weeks",
      startDate,
      endDate,
    });
  }

  /**
   * Creates a monthly schedule.
   * @param startDate - Optional start date (defaults to current date)
   * @param endDate - Optional end date
   * @returns A new ScheduleIterator for monthly occurrences
   */
  static monthly(startDate?: Date, endDate?: Date): ScheduleIterator {
    return ScheduleIterator.create({
      number: 1,
      unit: "months",
      startDate,
      endDate,
    });
  }

  /**
   * Creates a yearly schedule.
   * @param startDate - Optional start date (defaults to current date)
   * @param endDate - Optional end date
   * @returns A new ScheduleIterator for yearly occurrences
   */
  static yearly(startDate?: Date, endDate?: Date): ScheduleIterator {
    return ScheduleIterator.create({
      number: 1,
      unit: "years",
      startDate,
      endDate,
    });
  }

  /**
   * Creates a bi-weekly (every 2 weeks) schedule.
   * @param startDate - Optional start date (defaults to current date)
   * @param endDate - Optional end date
   * @returns A new ScheduleIterator for bi-weekly occurrences
   */
  static biweekly(startDate?: Date, endDate?: Date): ScheduleIterator {
    return ScheduleIterator.create({
      number: 2,
      unit: "weeks",
      startDate,
      endDate,
    });
  }

  /**
   * Creates a quarterly (every 3 months) schedule.
   * @param startDate - Optional start date (defaults to current date)
   * @param endDate - Optional end date
   * @returns A new ScheduleIterator for quarterly occurrences
   */
  static quarterly(startDate?: Date, endDate?: Date): ScheduleIterator {
    return ScheduleIterator.create({
      number: 3,
      unit: "months",
      startDate,
      endDate,
    });
  }
}
